<template>
  <div>

    <b-row>
      <b-col sm="3" md="5">
        <h4 class="font-weight-bold ml-1">Ordrer</h4>
      </b-col>

      


      <b-col sm="9" md="7" class="d-flex justify-content-end align-items-center">
      
            <div class="mr-3 text-center">

         <b-button
          variant="outline-secondary"
          class=""
          :disabled="!isOnline || isSyncingOfflineOrders"
          @click="syncOfflineOrders"
        >
          <b-spinner
            v-if="isSyncingOfflineOrders"
            small
            class="mr-1"
          ></b-spinner>
          <span>{{ isSyncingOfflineOrders ? 'Synkroniserer...' : 'Synkroniser offline' }}</span>
        </b-button>
        <small
          v-if="hasOfflineOrders && offlineOrdersLastSynced"
          class="text-muted mt-2"
        >
          Sist lagret {{ $date(offlineOrdersLastSynced).format('DD.MM.YYYY HH:mm') }}
        </small>


        </div>
      
        <b-form inline class="mb-0">
          <b-input-group>
            <b-input-group-prepend is-text>
              <i class="ion ion-ios-search"></i>
            </b-input-group-prepend>
            <b-form-input
              v-model="filter"
              @input="onFilterChange()"
              @keyup.enter="onFilterChange(filter)"
              placeholder="Søk"
              class=""
            />
          </b-input-group>
        </b-form>

            <b-button
          variant="primary"
          class="mb-2"
          v-b-modal.newOrder
          @click="openModal()"
        >
          Opprett ny ordre
        </b-button>

  


      </b-col>

      <!-- <b-col md="2">

        <b-form-checkbox class="mt-2 float-left" v-model="showAllOrders" v-on:change="updateOrders()">
          Vis alle ordrer
        </b-form-checkbox>
      </b-col> -->



    </b-row>

    <b-alert
      v-if="isShowingOfflineOrders"
      show
      variant="warning"
      class="mt-3"
    >
      <h6 class="alert-heading">Viser ordrer (Offline)</h6>
      <p class="mb-0">
        Disse dataene ble sist synkronisert
        <span v-if="offlineOrdersLastSynced">
          {{ $date(offlineOrdersLastSynced).format('DD.MM.YYYY HH:mm') }}.
        </span>
        <span v-else>tidligere.</span>
      </p>
    </b-alert>

    <b-alert
      v-else-if="!isOnline && !hasOfflineOrders"
      show
      variant="danger"
      class="mt-3"
    >
      Ingen ordrer er tilgjengelige offline. Koble til internett og bruk "Synkroniser offline".
    </b-alert>

    <b-alert
      v-if="offlineOrdersError"
      show
      variant="danger"
      class="mt-3"
    >
      {{ offlineOrdersError }}
    </b-alert>

    <!-- / User Interface controls -->

    <!-- Main table element -->

    <div>
      <b-table show-empty caption-top stacked="sm" :items="orders" :fields="fields" :current-page="currentPage"
        :per-page="perPage" :sort-by.sync="sortBy" :sort-direction="sortDirection" :hover="hoverTable"
        empty-text="Laster inn..">

        <!-- @row-clicked="(item) => $set(item, '_showDetails', !item._showDetails)" -->

        <template v-slot:table-caption>
          <b-row>
            <b-col md="2">
              <span> Totalt: {{ orders.length | numeralFormat }} ordrer</span>
            </b-col>

            <b-col md="1">


            </b-col>

            <b-col md="10">

            </b-col>
          </b-row>

        </template>

        <template v-slot:cell(status)="data">
          <b-badge pill v-if="data.item.status == 'Bestilling'" variant="secondary">{{ data.item.status }} </b-badge>
          <b-badge pill v-if="data.item.status == 'Ordre'" variant="primary">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'I arbeid'" variant="dark">{{ data.item.status }}  </b-badge>
          <b-badge pill v-if="data.item.status == 'Arbeid avsluttet'" variant="warning">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'Til fakturering'" variant="info">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'Fakturert'" variant="success">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'Utført'" variant="success">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'Kansellert'" variant="danger">{{ data.item.status }}</b-badge>
        </template>

        <template v-slot:cell(ordertitle)="data">
          <b-link
            class="link"
            :to="getOrderRouteTarget(data.item)"
          >
            <span v-if="data.item.title != null">
              {{ data.item.title }}
            </span>
          </b-link>
        </template>

        <template v-slot:cell(vessel)="data">
          <span>{{ data.item.vessel }}</span>
        </template>

        <template v-slot:cell(captain)="data">
          <span>{{ data.item.captain }}</span>
        </template>

        <!-- format a single date -->
        <template v-slot:cell(startdate)="data">
          <span v-if="data.item.startdate">
            {{ $date(data.value).format('DD.MM.YYYY') }}
          </span>
        </template>

        <!-- humanize relative time -->
        <template v-slot:cell(updatedAt)="data">
          <span v-if="data.item.updatedAt">
            {{ $date(data.value).from() }}
          </span>
        </template>

        <template v-slot:cell(attachments)="data">
          <span v-if="data.item.attachments.length != 0"><i class="ion ion-ios-attach"></i></span>
        </template>


        <template #cell(actions)="row">
          <b-button variant="primary" class="mr-1 float-center" size="sm" @click="editOrder(row.item.id)">
            Rediger</b-button>
        </template>

        <!-- Order details in table -->

        <!-- <template #row-details="row">
          <b-card>
            <b-row>
              <b-col>
                <h5>Ordre</h5>
                <hr />

                <b-form-group label="Kunde">
                  <vue-typeahead-bootstrap
                    class="mb-2"
                    v-model="queryCustomer"
                    :ieCloseFix="false"
                    :data="customers"
                    :serializer="(item) => item.name"
                    @hit="row.item.customer_company = $event"
                    placeholder="Søk kunde"
                    @input="lookupCustomer"
                  />
                </b-form-group>

                <b-form-group label="Type">
                  <b-form-select
                    class="mr-3 mb-1"
                    v-model="row.item.type"
                    :options="orderType"
                    placeholder="Type"
                  ></b-form-select>
                </b-form-group>

                <b-form-group label="Lokasjon">
                  <vue-typeahead-bootstrap
                    class="mr-3 mb-1"
                    v-model="querySites"
                    :ieCloseFix="false"
                    :data="sites"
                    :serializer="(item) => item.number + ' - ' + item.name"
                    @hit="row.item.site = $event"
                    placeholder="Søk lokaliteter"
                    @input="lookupSites"
                  />
                </b-form-group>

                <b-form-group label="Startdato">
                  <datepicker
                    class="mr-3 mb-1"
                    v-model="row.item.startdate"
                    :format="customFormatter"
                    :bootstrap-styling="true"
                    :disabled-dates="disabledDates"
                  >
                  </datepicker>
                </b-form-group>

                <b-form-group label="Fartøy">
                  <b-form-select
                    class="mr-3 mb-1"
                    v-model="row.item.vessel"
                    :options="vesselSelect"
                  ></b-form-select>
                </b-form-group>

                <b-form-group label="Kaptein">
                  <b-form-select
                    class="mr-3 mb-3"
                    v-model="row.item.captain"
                    :options="captainSelect"
                  ></b-form-select>
                </b-form-group>

                <b-form-group label="Status">
                  <b-form-select
                    class="mr-3 mb-1"
                    v-model="row.item.status"
                    :options="statusOptions"
                    placeholder="status"
                  ></b-form-select>
                </b-form-group>

                <b-form-checkbox v-model="row.item.confirmation">
                  Send ordrebekreftelse
                </b-form-checkbox>

                <hr />

                <b-button
                  variant="primary"
                  @click="updateOrder(row.item)"
                >Oppdater ordre</b-button>

                <b-button
                  variant="defalt"
                  @click="row.toggleDetails"
                >Lukk</b-button>
              </b-col>

              <b-col>
                <h5>Detaljer</h5>
                <hr />

                Ordrenummer:
                <h5>
                  {{ row.item.ordernumber }}
                </h5>

                Kunde:
                <h5>
                  {{ row.item.customer_company.name }}
                </h5>

                Type:
                <h5>
                  {{ row.item.type }}
                </h5>

                <div v-if="order.contact  != null">
                  Kontaktperson:
                  <h5>{{ order.contact }}</h5>
                </div>

                <div v-if="order.email != null">
                  E-post:
                  <h5>{{ order.email }}</h5>
                </div>

                <div v-if="order.phone != null">
                  Telefon:
                  <h5>{{ order.phone }}</h5>
                </div>

                <div v-if="row.item.site != null">
                  Lokasjon:
                  <h5>
                    {{ row.item.site.number }} -
                    {{ row.item.site.name }}
                  </h5>
                </div>

                <div v-if="row.item.vessel != null">
                  Fartøy:
                  <h5 v-if="row.item.vessel != null">
                    {{ row.item.vessel.name }}
                  </h5>
                </div>

                <div v-if="row.item.captain != null">
                  Skipper:
                  <h5 v-if="row.item.vessel != null">
                    {{ row.item.captain.name }}
                  </h5>
                </div>

               <vue-json-pretty :data="row.item"> </vue-json-pretty> 
        </b-col>
        </b-row>
        </b-card>
</template> -->
      </b-table>

      <b-row>
        <b-col md="1" class="my-1">
          <b-form-group class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="2" class="my-1">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </div>


    <!--   -->
    <!-- New order modal -->
    <!--   -->

    <b-modal id="newOrder" size="xl" title="Ny ordre">
      <b-row>
        <b-col md="6">

          <b-form-group label="Ordrenummer" label-for="name-input">
            <b-form-input id="name-input" v-model="order.ordernumber" disabled></b-form-input>
          </b-form-group>

          <b-form-group inline v-if="showNewCustomer == false" label="Kunde">
            <vue-typeahead-bootstrap class="mb-2" v-model="queryCustomerNew" :ieCloseFix="false" :data="customers"
              :serializer="(item) => item.name" @hit="order.customer_company = $event" placeholder="Søk kunde"
              @input="lookupCustomer" />

            <b-button variant="outline-primary" size="sm" v-b-modal.newCustomer @click="openCustomerModal()">Opprett ny
              kunde</b-button>
          </b-form-group>

          <b-form-group v-if="showNewCustomer == true" :label="$t('wizard.companyname')">
            <b-input disabled v-model="newcompany.name" required autofocus />
          </b-form-group>

          <b-form-group label="Startdato">
            <datepicker class="mr-3 mb-1" v-model="order.startdate" :format="customFormatter" :bootstrap-styling="true"
              :disabled-dates="disabledDates">
            </datepicker>
          </b-form-group>

          <b-form-group label="Sluttdato">
            <datepicker class="mr-3 mb-1" v-model="order.enddate" :format="customFormatter" :bootstrap-styling="true"
              :disabled-dates="disabledDates">
            </datepicker>
          </b-form-group>

          <b-form-group label="Fartøy">
            <b-form-select class="mr-3 mb-1" v-model="order.vessel" :options="vesselSelect"></b-form-select>
          </b-form-group>

          <b-form-group label="Kaptein">
            <b-form-select class="mr-3 mb-3" v-model="order.captain" :options="captainSelect"></b-form-select>
          </b-form-group>

          <b-form-group label="Status">
            <b-form-select class="mr-3 mb-1" v-model="order.status" :options="statusOptions" placeholder="status">
            </b-form-select>
          </b-form-group>

        </b-col>

        <b-col md="6">

          <b-form-group label="Type">
            <b-form-select class="mr-3 mb-1" v-model="order.type" :options="orderType" placeholder="Type">
            </b-form-select>
          </b-form-group>

          <b-form-group label="Lokasjon">
            <vue-typeahead-bootstrap class="mr-3 mb-1" v-model="querySites" :ieCloseFix="false" :data="sites"
              :serializer="(item) => item.number + ' - ' + item.name" @hit="order.site = $event"
              placeholder="Søk lokaliteter" @input="lookupSites" />
          </b-form-group>

          <div class="mb-1">
            <b-form-group label="Kontaktperson:">
              <b-input v-model="order.contact_name"></b-input>
            </b-form-group>
          </div>

          <div class="mb-1">
            <b-form-group label="E-post:">
              <b-input v-model="order.contact_email1 "></b-input>
            </b-form-group>
          </div>

          <div class="mb-1">
            <b-form-group label="E-post (Alternativ):">
              <b-input v-model="order.contact_email2"></b-input>
            </b-form-group>
          </div>

          <div class="mb-1">
            <b-form-group label="Telefon">
              <b-input v-model="order.contact_phone"></b-input>
            </b-form-group>
          </div>

          <b-form-group label="Tilleggsinformasjon">
            <b-form-textarea v-model="order.details.note" placeholder="" rows="5" max-rows="5"></b-form-textarea>
          </b-form-group>

        </b-col>
      </b-row>

      <template #modal-footer>
        <div class="w-100">

          <b-button variant="primary" class="float-right" @click="saveOrder()">
            Opprett ordre
          </b-button>

          <b-button variant="default" class="float-right mr-2" @click="closeModal()">
            Avbryt
          </b-button>

          <b-form-checkbox class="mt-2 mr-5 float-right" v-model="order.send_confirmation">
            Send ordrebekreftelse
          </b-form-checkbox>

        </div>
      </template>
    </b-modal>

    <!--   -->
    <!-- New customer modal -->
    <!--   -->

    <b-modal id="newCustomer" title="Ny kunde">
      <!-- Add company number and get details from Bbreg -->

      <label class="mt-1"> {{ $t("wizard.orgnumber") }}</label>
      <b-form class="mb-3" inline>
        <b-form-group>
          <b-input v-model="newcompany.orgnumber" placeholder="Organisasjonsnummer" required type="number" trim
            no-wheel />
        </b-form-group>

        <b-button class="ml-3" variant="link" @click="getNewCustomer()">Hent opplysninger</b-button>
      </b-form>

      <b-form-group :label="$t('wizard.companyname')">
        <b-input disabled v-model="newcompany.name" required autofocus />
      </b-form-group>

      <b-form-group :label="$t('wizard.address')">
        <b-input disabled v-model="newcompany.address" required autofocus />
      </b-form-group>

      <b-form-group :label="$t('wizard.postcode')">
        <b-input disabled v-model="newcompany.postcode" required autofocus />
      </b-form-group>

      <b-form-group :label="$t('wizard.city')">
        <b-input disabled v-model="newcompany.city" required autofocus />
      </b-form-group>

      <b-form-group :label="$t('wizard.country')">
        <b-input disabled v-model="newcompany.country" required autofocus />
      </b-form-group>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" class="float-right" @click="createCustomer()">
            Opprett kunde
          </b-button>

          <b-button variant="default" class="float-right mr-2" @click="closeCustomerModal()">
            Avbryt
          </b-button>
        </div>
      </template>
    </b-modal>

  </div>

</template>

<script>
  import axios from "axios";
  
  import Datepicker from "vuejs-datepicker";
  
  import VueMoment from "vue-moment";
  import moment from "moment";
  import {
    debounce
  } from "lodash";
  import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
  import { BOverlay } from "bootstrap-vue";
  import { VueOffline, VueOfflineStorage } from 'vue-offline';

  const OFFLINE_ORDERS_STORAGE_KEY = "orders-offline-cache";
  const OFFLINE_ORDER_SNAPSHOT_PREFIX = "order-snapshot-";

  export default {
    components: {
      BOverlay,
      Datepicker,
      
      VueMoment,
      moment,
      VueTypeaheadBootstrap,
      VueOfflineStorage,
      VueOffline,
    },
    data() {
      return {
        user: {},
        order: {
          status: "Bestilling",
          type: "Avlusning",
          details: {
            cages: [],
          },
          site: [],
        },
        orders: [],
        offlineOrders: [],
        offlineOrdersSyncedAt: null,
        isSyncingOfflineOrders: false,
        offlineOrdersError: null,
        company: {},
        newcompany: {},
        newconfirmation: false,
        site: "",
        sites: [],
        customers: [],
        captainSelect: [],  
        showAllOrders: null,
        lastUpdate: {},
        fromDate: {},
        toDate: {},
        disabledDates: {},
        lookupCustomer: "",
        queryCustomer: "",
        queryCustomerNew: "",
        querySites: "",
        showNewCustomer: false,
        fields: [{
            key: "status",
            label: "Status",
            sortable: true
          },
          {
            key: "ordertitle",
            label: "Ordre",
            sortable: true,
            class: "text-left",
          },

          {
            key: "type",
            label: "Type",
            sortable: true
          },
          {
            key: "vessel",
            label: "Fartøy",
            sortable: true
          },
          {
            key: "captain",
            label: "Kaptein",
            sortable: true
          },
          {
            key: "startdate",
            label: "Startdato",
            sortable: true
          },
          {
            key: "updatedAt",
            label: "Sist oppdatert",
            sortable: true
          },
          {
            key: "attachments",
            label: "",
          },
          {
            key: "actions",
            label: "",
          }
        ],
        orderType: [{
            value: "Avlusning",
            text: "Avlusning"
          },
          {
            value: "Notspyling",
            text: "Notspyling"
          },
          {
            value: "Servicearbeid",
            text: "Servicearbeid"
          },
          {
            value: "Brønnbåt",
            text: "Brønnbåt"
          },
        ],
        statusOptions: [{
            value: "Bestilling",
            text: "Bestilling"
          },
          {
            value: "Ordre",
            text: "Ordre"
          },
          {
            value: "I arbeid",
            text: "I arbeid"
          },
          {
            value: "Arbeid avsluttet",
            text: "Arbeid avsluttet"
          },
          {
            value: "Utført",
            text: "Utført"
          },
          {
            value: "Kansellert",
            text: "Kansellert"
          },
        ],
        vesselSelect: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 100,
        pageOptions: [25, 50, 100, 250, 500, 1000],
        sortBy: "created",
        sortDesc: true,
        sortDirection: "desc",
        filter: null,
        hoverTable: true,
        limit: 1000,
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        isLoading: false,
        fullPage: true,
      };
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => {
            return {
              text: f.label,
              value: f.key
            };
          });
      },
      sumOrdersTotal() {
        return this.orders.length;
      },
      hasOfflineOrders() {
        return this.offlineOrders.length > 0;
      },
      isShowingOfflineOrders() {
        return !this.isOnline && this.hasOfflineOrders;
      },
      offlineOrdersLastSynced() {
        return this.offlineOrdersSyncedAt;
      },
    },
    watch: {
      isOnline(status) {
        if (status) {
          if (this.user && this.user.id) {
            this.getOrders({ persistOffline: false, useOfflineCache: false });
          }
        } else {
          this.orders = this.offlineOrders.slice();
          this.totalRows = this.orders.length;
        }
      },
    },
    methods: {
      getOrderRouteTarget(order) {
        const id = (order && order.id) || order;
        if (!id) {
          return null;
        }
        return this.isOnline
          ? { name: "order-edit", params: { id } }
          : { name: "order-edit-offline", params: { id } };
      },
      navigateToOrder(order) {
        const target = this.getOrderRouteTarget(order);
        if (target) {
          this.$router.push(target);
        }
      },
      getOfflineOrdersKey() {
        const companyId = localStorage.getItem("company") || (this.company && this.company.id);
        return companyId ? `${OFFLINE_ORDERS_STORAGE_KEY}-${companyId}` : OFFLINE_ORDERS_STORAGE_KEY;
      },
      loadOfflineOrders() {
        if (!this.$offlineStorage) {
          this.offlineOrders = [];
          this.offlineOrdersSyncedAt = null;
          return;
        }
        const cached = this.$offlineStorage.get(this.getOfflineOrdersKey());
        if (cached && Array.isArray(cached.orders)) {
          this.offlineOrders = cached.orders;
          this.offlineOrdersSyncedAt = cached.syncedAt || null;
        } else {
          this.offlineOrders = [];
          this.offlineOrdersSyncedAt = null;
        }
      },
      persistOfflineOrders(orders) {
        if (!this.$offlineStorage) {
          return;
        }
        const payload = {
          syncedAt: new Date().toISOString(),
          orders: JSON.parse(JSON.stringify(orders)),
        };
        this.$offlineStorage.set(this.getOfflineOrdersKey(), payload);
        this.offlineOrders = payload.orders;
        this.offlineOrdersSyncedAt = payload.syncedAt;
        this.persistOfflineOrderSnapshots(payload.orders);
      },
      persistOfflineOrderSnapshots(orders = []) {
        if (!this.$offlineStorage) {
          return;
        }
        
        // Only store active orders (not "Avsluttet" status) to prevent quota exceeded
        const activeOrders = orders.filter(order => 
          order && order.status && order.status !== 'Avsluttet'
        );
        
        activeOrders.forEach((order) => {
          if (!order || !order.id) {
            return;
          }
          
          // Only store essential fields to save space
          const snapshot = {
            id: order.id,
            ordernumber: order.ordernumber,
            status: order.status,
            title: order.title,
            type: order.type,
            customer_company: order.customer_company ? {
              id: order.customer_company.id,
              name: order.customer_company.name
            } : null,
            site: order.site ? {
              id: order.site.id,
              name: order.site.name,
              number: order.site.number
            } : null,
            vessel: order.vessel ? {
              id: order.vessel.id,
              name: order.vessel.name
            } : null,
            orderdate: order.orderdate,
            deadline: order.deadline,
            // Include FLS and arbeidslogg for offline editing
            fls: order.fls || [],
            worklogs: order.worklogs || [],
          };
          
          try {
            this.$offlineStorage.set(`${OFFLINE_ORDER_SNAPSHOT_PREFIX}${order.id}`, snapshot);
          } catch (e) {
            // If quota exceeded, silently skip this order
            console.warn(`Could not save snapshot for order ${order.id}:`, e.message);
          }
        });
      },
      persistOfflineOrderSnapshot(order) {
        if (!this.$offlineStorage || !order || !order.id) {
          return;
        }
        
        // Only store essential fields to save space
        const snapshot = {
          id: order.id,
          ordernumber: order.ordernumber,
          status: order.status,
          title: order.title,
          type: order.type,
          customer_company: order.customer_company ? {
            id: order.customer_company.id,
            name: order.customer_company.name
          } : null,
          site: order.site ? {
            id: order.site.id,
            name: order.site.name,
            number: order.site.number
          } : null,
          vessel: order.vessel ? {
            id: order.vessel.id,
            name: order.vessel.name
          } : null,
          orderdate: order.orderdate,
          deadline: order.deadline,
          // Include FLS and arbeidslogg for offline editing
          fls: order.fls || [],
          worklogs: order.worklogs || [],
        };
        
        try {
          this.$offlineStorage.set(`${OFFLINE_ORDER_SNAPSHOT_PREFIX}${order.id}`, snapshot);
        } catch (e) {
          console.warn(`Could not save snapshot for order ${order.id}:`, e.message);
        }
      },
      filterOfflineOrders(term) {
        if (!term) {
          return this.offlineOrders.slice();
        }
        const query = term.toString().toLowerCase();
        return this.offlineOrders.filter((order) => {
          const values = [
            order && order.ordernumber,
            order && order.status,
            order && order.title,
            order && order.site && order.site.name,
            order && order.customer_company && order.customer_company.name,
          ];
          return values.some((value) => value && value.toString().toLowerCase().includes(query));
        });
      },
      async syncOfflineOrders() {
        if (!this.isOnline || this.isSyncingOfflineOrders) {
          return;
        }
        this.isSyncingOfflineOrders = true;
        this.offlineOrdersError = null;
        try {
          const fetched = await this.getOrders({ persistOffline: true, useOfflineCache: false });
          if (!fetched) {
            this.offlineOrdersError = "Kunne ikke oppdatere offline-ordrer. Prøv igjen når du har stabil tilkobling.";
            if (this.offlineOrders.length) {
              this.orders = this.offlineOrders.slice();
              this.totalRows = this.orders.length;
            }
          }
        } finally {
          this.isSyncingOfflineOrders = false;
        }
      },
      getUser() {
        this.isLoading = true;

        axios
          .get("https://api.eines-as.no/users/me")
          .then((res) => {
            this.user = res.data;
            this.company = res.data.company;
            this.order.ordernumber = res.data.company.ordernumber;
            this.order.supplier_company = res.data.company;

            this.getOrders();
            this.isLoading = false;
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
            if (!this.isOnline && this.offlineOrders.length) {
              this.orders = this.offlineOrders.slice();
              this.totalRows = this.orders.length;
            } else if (!this.offlineOrdersError) {
              this.offlineOrdersError = "Kunne ikke laste ordrer. Viser siste tilgjengelige data dersom de er lagret offline.";
            }
          });
      },
      async getOrders(options = {}) {
        const { persistOffline = true, useOfflineCache = true } = options;
        this.isLoading = true;
        let fetchedFromServer = false;

        if (!this.isOnline) {
          if (useOfflineCache) {
            this.orders = this.offlineOrders.slice();
            this.totalRows = this.orders.length;
          }
          this.isLoading = false;
          return fetchedFromServer;
        }

        this.orders = [];

        try {
          const companyId =
            localStorage.getItem("company") || (this.company && this.company.id);

          if (!companyId) {
            this.totalRows = 0;
            return fetchedFromServer;
          }

          const allStatuses = [
            "Bestilling",
            "Ordre",
            "I arbeid",
            "Arbeid avsluttet",
            "Til fakturering",
            "Klar til fakturering"
          ];
          const limitedStatuses = ["Ordre", "I arbeid", "Arbeid avsluttet"];
          const statuses =
            this.user && this.user.role && this.user.role.id === "600fe2dc0b7e124b5c5f7f3b"
              ? allStatuses
              : limitedStatuses;

          const statusQuery = statuses
            .map((s) => `status_eq=${encodeURIComponent(s)}`)
            .join("&");

          const url = `https://api.eines-as.no/orders/list?_limit=-1&_sort=ordernumber:DESC&_where[supplier_company]=${companyId}`;

          const res = await axios.get(url);
          this.orders = res.data;
          this.totalRows = this.orders.length;
          fetchedFromServer = true;

          this.orders.forEach((order) => {
            const starts = order.worklogs
              .filter((w) => w.from && w.from !== w.to)
              .map((w) => w.from);
            const ends = order.worklogs
              .filter((w) => w.to && w.to !== w.from)
              .map((w) => w.to);

            if (starts.length) {
              order.startdate = _.min(starts);
            }
            if (ends.length) {
              order.enddate = _.max(ends);
            }
          });

          if (persistOffline) {
            this.persistOfflineOrders(this.orders);
          }

          this.offlineOrdersError = null;
        } catch (err) {
          console.error("Error loading orders:", err);
          if (useOfflineCache && this.offlineOrders.length) {
            this.orders = this.offlineOrders.slice();
            this.totalRows = this.orders.length;
          }
        } finally {
          this.isLoading = false;
        }

        return fetchedFromServer;
      },
      async updateOrders(search) {
        this.isLoading = true;

        this.orders = [];

        if (!this.isOnline) {
          const filtered = this.filterOfflineOrders(search);
          this.orders = filtered;
          this.totalRows = this.orders.length;
          this.isLoading = false;
          return;
        }

        try {
          const companyId = localStorage.getItem("company");
          const allStatuses = [
            "Bestilling",
            "Ordre",
            "I arbeid",
            "Arbeid avsluttet",
            "Til fakturering",
            "Klar til fakturering"
          ];
          const limitedStatuses = ["Ordre", "I arbeid", "Arbeid avsluttet"];
          const statuses =
            this.user && this.user.role && this.user.role.id === "600fe2dc0b7e124b5c5f7f3b"
              ? allStatuses
              : limitedStatuses;

          const statusQuery = statuses
            .map((s) => `status_eq=${encodeURIComponent(s)}`)
            .join("&");

          const url = `https://api.eines-as.no/orders/list?_q=${search}&_limit=-1&_sort=ordernumber:DESC&_where[supplier_company]=${companyId}`;

          const res = await axios.get(url);
          this.orders = res.data;
          this.totalRows = this.orders.length;
        } catch (err) {
          console.error("Error loading orders:", err);
          if (this.offlineOrders.length) {
            const fallback = this.filterOfflineOrders(search);
            this.orders = fallback;
            this.totalRows = this.orders.length;
          }
        } finally {
          this.isLoading = false;
        }
      },
      onFilterChange: debounce(function () {

        if (this.filter != null && this.filter !== "") {
          if (this.isOnline) {
            this.updateOrders(this.filter);
          } else {
            this.orders = this.filterOfflineOrders(this.filter);
            this.totalRows = this.orders.length;
          }
        } else {
          if (this.isOnline) {
            this.getOrders();
          } else {
            this.orders = this.offlineOrders.slice();
            this.totalRows = this.orders.length;
          }
        }

      }, 300),

      getCustomers() {
        axios
          .get("https://api.eines-as.no/companies?_where[type]=Customer")
          .then((res) => {
            this.customers = res.data;
          });
      },
      getVessels() {
        var company = localStorage.getItem("company");

        axios
          .get("https://api.eines-as.no/vessels?_where[company]=" + company)
          .then((response) => {
            var vesselSelect = [];
            var vesselDataArray = response.data;

            vesselDataArray.forEach((data) => {
              var vesselObject = {
                value: data,
                text: data.name,
              };
              vesselSelect.push(vesselObject);
            });

            this.vesselSelect = vesselSelect;
          });
      },
      getCaptain() {
        const company = localStorage.getItem('company')
        axios
          .get(`https://api.eines-as.no/crews?_where[company]=${company}`)
          .then(resp => {
            this.captainSelect = resp.data.map(c => ({
              value:  c,
              text:   c.name
            }))
          })
      },
      getSites() {
        this.isLoading = true;
        axios
          .get("https://api.eines-as.no/aquaregisters?_limit=-1")
          .then((res) => {
            this.sites = res.data;
            this.isLoading = false;
          });
      },
      createCustomer() {
        axios
          .post("https://api.eines-as.no/companies/", this.newcompany)
          .then((response) => {
            this.order.customer_company = response.data;
            this.showNewCustomer = true;
            this.$bvModal.hide("newCustomer");
          })
          .catch((error) => {
            console.log(error);
          });
      },
      saveOrder() {
        // Send order confirmation

        if (this.order.send_confirmation == true) {
          this.order.send_confirmation = false;

          var message = {
            to: this.order.contact_email1, 
            subject: 'Ordrebekreftelse fra ' + this.order.supplier_company.name,
            template: '60462ff735f1aa48189844e4',
            details: {
              order: this.order,
              ordernumber: this.order.ordernumber,
              ordertype: this.order.type,
              url: 'https://www.aquaservices.no/#/customer/orders',
              supplier_company: this.order.supplier_company.name,
              customer_company: this.order.customer_company.name,
            }
          };

          if (this.order.created_email != null) {
            message.cc = this.order.created_email
          }

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {})
            .catch((error) => {
              console.log(error);
              this.isLoading = false;
            });
        }

        axios
          .post("https://api.eines-as.no/orders/", this.order)
          .then((response) => {
            this.$bvModal.hide("newOrder");
            this.navigateToOrder(response.data.id);

            if (this.newconfirmation == true) {
              this.sendConfirmation(response.data);
            }

              this.navigateToOrder(orderId);
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
          });
      },
      updateOrder(order) {
        this.isLoading = true;

        // Send order confirmation

        if (this.order.send_confirmation == true) {
          this.order.send_confirmation = false;

          var message = {
            to: this.order.contact_email1, 
            subject: 'Ordrebekreftelse fra ' + this.order.supplier_company.name,
            template: '60462ff735f1aa48189844e4',
            details: {
              order: this.order,
              ordernumber: this.order.ordernumber,
              ordertype: this.order.type,
              url: 'https://www.aquaservices.no/#/customer/orders',
              supplier_company: this.order.supplier_company.name,
              customer_company: this.order.customer_company.name,
            }
          };

          if (this.order.created_email != null) {
            message.cc = this.order.created_email
          }

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {})
            .catch((error) => {
              console.log(error);
              this.isLoading = false;
            });
        }

        axios
          .put("https://api.eines-as.no/orders/" + order.id, order)
          .then((response) => {
            this.queryCustomer = "";
            this.isLoading = false;
            this.getOrders();
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
          });
      },
      getNewCustomer() {
        axios
          .get(
            "https://data.brreg.no/enhetsregisteret/api/enheter/" +
            this.newcompany.orgnumber
          )
          .then((response) => {
            var companyInfo = {
              name: response.data.navn,
              orgnumber: response.data.organisasjonsnummer,
              address: response.data.forretningsadresse.adresse[0],
              postcode: response.data.forretningsadresse.postnummer,
              city: response.data.forretningsadresse.poststed,
              country: response.data.forretningsadresse.land,
              details: {
                registered: response.data.registreringsdatoEnhetsregisteret,
                employees: response.data.antallAnsatte,
                sector: response.data.naeringskode1.beskrivelse,
              },
              type: "Customer",
            };

            this.newcompany = companyInfo;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      changeCustomer() {
        this.order.contact_name = this.order.customer_company.contact;
        this.order.contact_email1 = this.order.customer_company.email;
        this.order.contact_email2 = this.order.customer_company.email2;
        this.order.contact_phone = this.order.customer_company.phone;
      },
      lookupSites: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(`https://api.eines-as.no/sites?_q=${this.querySites}`)
          .then((response) => {
            this.sites = response.data;
          });
      }, 100),
      editOrder(orderId) {
        // Use navigateToOrder to route based on connectivity status
        this.navigateToOrder({ id: orderId });
      },
      openModal() {
        this.getCustomers();
      },
      closeModal() {
        this.$bvModal.hide("newOrder");
      },
      closeCustomerModal() {
        this.$bvModal.hide("newCustomer");
      },
      customFormatter(date) {
        return moment(date).format("DD.MM.YYYY");
      },
      getDates() {
        this.order.startdate = new Date();
        this.order.enddate = new Date();
        this.order.startdate.setDate(this.order.startdate.getDate() + 5);
        this.order.enddate.setDate(this.order.enddate.getDate() + 8);

        this.disabledDates = {
          to: new Date(),
        };
      },
    },
    created: function () {
      this.loadOfflineOrders();
      if (!this.isOnline && this.offlineOrders.length) {
        this.orders = this.offlineOrders.slice();
        this.totalRows = this.orders.length;
      }
      this.getUser();
    },
  };

</script>

<style lang="css">
  .country-flag {
    max-width: 20px;
    box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
  }

  .background-white {
    background: #ffffff;
  }

  /*
 * Link
 */

  /* Links */

  .link {
    color: #484848;
  }

  /* unvisited link */
  .link:link {
    color: #484848 !important;
  }

  /* visited link */
  .link:visited {
    color: #484848 !important;
  }

  /* mouse over link */
  .link:hover {
    color: #6e6e6e !important;
  }

  /* selected link */
  .link:active {
    color: #484848 !important;
  }

</style>
